import * as React from 'react';
export const rainbowSvg = React.forwardRef(function rainbowSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_rainbow__a)',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.333 10.133h1.6c8.248 0 14.934 6.686 14.934 14.934v1.6h3.2a1.6 1.6 0 0 0 1.6-1.6c0-10.899-8.835-19.734-19.734-19.734a1.6 1.6 0 0 0-1.6 1.6v3.2Z',
      fill: 'url(#bi_rainbow__b)',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.333 9.6h1.6c8.542 0 15.467 6.925 15.467 15.467v1.6h-4.8v-1.6c0-5.891-4.776-10.667-10.667-10.667h-1.6V9.6Z',
      fill: 'url(#bi_rainbow__c)',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.333 16.533a1.6 1.6 0 0 0 1.6 1.6 6.933 6.933 0 0 1 6.934 6.934 1.6 1.6 0 0 0 1.6 1.6h2.666v-1.6c0-6.186-5.014-11.2-11.2-11.2h-1.6v2.666Z',
      fill: 'url(#bi_rainbow__d)',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: 'bi_rainbow__b',
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform: 'rotate(-90 16 9.067) scale(19.7333)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.77,
          stopColor: '#FF4000',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#8754C9',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: 'bi_rainbow__c',
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform: 'rotate(-90 16 9.067) scale(15.4667)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.724,
          stopColor: '#FFF700',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#FF9901',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: 'bi_rainbow__d',
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform: 'rotate(-90 16 9.067) scale(11.2)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.595,
          stopColor: '#0AF',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#01DA40',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_rainbow__a',
          x1: 16,
          y1: 0,
          x2: 16,
          y2: 32,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#174299',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#001E59',
        }),
      ),
    ),
  );
});
rainbowSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var rainbow = {
  category: 'brand',
  colorable: false,
  name: 'rainbow',
  svg: rainbowSvg,
};
